export enum RelationTypeEnum {
  Outbound = 'Outbound',
  Inbound = 'Inbound',
}
